import type { Response } from '@my/call-api';

export type GetUploadFileToken = (params: {
  suffix: string;
  customUploadCallApi?: (params: { suffix: string }) => Promise<GetUploadResult>;
}) => Promise<Response<GetUploadResult>>;

export enum UpdateClientType {
  /**
   * 七牛
   */
  QINIU = 'QINIU',
  /**
   * 腾讯云对象存储
   */
  COS = 'COS',
  /**
   * 腾讯云CDN
   */
  CDN = 'CDN',
  /**
   * S3
   */
  S3 = 'S3', // 能上传、访问需要签名（未使用 未对接）
  S3_CDN = 'S3_CDN',
}
export interface GetUploadResult {
  /**
   * 对象存储类型
   */
  osClientType?: keyof typeof UpdateClientType;

  token?: Token;

  transferUrl?: string;
}
export interface Token {
  /** @description 访问令牌 */
  token?: string;
  /**
   * Format: date-time
   * @description 到期时间
   */
  expiresAt?: string;

  key?: string;
  /**
   * @description 文件地址前缀
   * @example https://cos.suredoc.cn
   */
  urlprefix?: string;
  /** @description 上传成功后完整文件地址，不带签名 */
  fileUrl?: string;
  /** @description 文件上传URL */
  url?: string;
  /** @description 上传文件时要添加的请求头 */
  requestHeaders?: { [key: string]: string };
  /** @description 文件相对路径 */
  keys?: string[];
  /** @description 临时SecretId */
  tmpSecretId?: string;
  /** @description 临时SecretKey */
  tmpSecretKey?: string;
  /** @description 存储桶名 */
  bucketName?: string;
  /** @description 区域 */
  regionName?: string;
}
export interface Err {
  error: {
    Code: number;
    Message: string;
  };
}
